export const GET_WORK_TIME = 'GET_WORK_TIME';
export const GET_BREAK_TIME = 'GET_BREAK_TIME';
export const DELETE_ITEMS = 'DELETE_ITEMS';

export const CHANGE_STATUS_ITEMS = 'CHANGE_STATUS_ITEMS';
